<template>
  <div style="color: green">
    <div
      class="
        testrankingbar
        d-flex
        align-items-center
        justify-content-between
        position-relative
        mt-5
      "
    >
      <div class="text-pos d-flex align-items-start">
        <div class="d-flex align-items-center">
          <span class="cp-datetext"> Min.&nbsp;%:</span>
          <span class="cp-asmnttext"> 00 </span>
        </div>
      </div>
      <div
        class="average-negative align-items-center"
        :style="[
          licenseAvg == 0 ? 'left: 0px' : '',
          licenseAvg && licenseAvg == maxPercent
            ? { right: 0 }
            : licenseAvg < 0
            ? 'left:0px'
            : licenseAvg > maxPercent
            ? 'right:0px'
            : {
                left: (licenseAvg / maxPercent) * 90 + '%',
              },
        ]"
      >
        <div
          class="avg-marks"
          :style="
            licenseAvg == maxPercent && licenseAvg != 0
              ? 'right:0px'
              : licenseAvg == 0 || licenseAvg < 0
              ? 'left:0px'
              : 'left:-40px'
          "
        >
          <span class="cp-datetext">License avg. :</span>
          &nbsp;
          <span class="cp-asmnttext"> {{ licenseAvg }} % </span>
        </div>
      </div>
      <div class="text-pos d-flex align-items-end">
        <div class="d-flex align-items-center">
          <span class="cp-datetext"> Max.&nbsp;%: </span>
          &nbsp;
          <span class="cp-asmnttext"> 100 </span>
        </div>
      </div>
      <!-- <template v-if="hasNegative">
				<div
					id="negative-circle"
					class="d-flex align-items-center justify-content-center positive-circle pointer negative-circle"
					:style="{
						left: (0.1 / candScore) * 84 + '%',
					}"
					@mouseenter="toggleNegativeMarks"
					@mouseleave="toggleNegativeMarks"
				>
					<img src="../assets/newdesign/jobsearch/negmark-dp.svg" alt="" />
					<div class="position-relative">
						<div class="negative-mark-box" v-if="showNegativeMarks">
							<div class="neg-txt-1 mb-2">Negative Mark</div>
							<template v-for="(attempts, mark) in marks">
								<div
									:key="mark"
									v-if="mark < 0"
									class="d-flex align-items-center justify-content-between"
								>
									<div class="neg-txt-2">
										Attempt
										{{ attempts.map((a) => a + 1).join(", ") }}
									</div>
									<div class="neg-red-txt">{{ mark }}</div>
								</div>
							</template>
						</div>
					</div>
				</div>
			</template> -->

      <div
        v-if="candScore >= 0"
        class="
          d-flex
          align-items-center
          justify-content-center
          positive-circle
          pointer
        "
        :key="candScore"
        :class="[
          candScore >= licenseAvg ? candScore + 'cards' : 'negative-circle',
        ]"
        :id="candScore + 'cards'"
        @mouseover="startMouseOver('cards', candScore)"
        @mouseleave="stopMouseOver('cards', candScore, candScore)"
        :style="[
          {
            left: candScore >= 0 ? (candScore / maxPercent) * 96 + '%' : '5%',
          },
          { zIndex: candScore >= 0 ? candScore : 0 },
        ]"
      >
        <span v-if="candScore >= 0" class="cp-asmnttext-new">{{
          candScore
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    licenseAvg: Number,
    candScore: Number,
    candidate: Object,
  },
  data() {
    return {
      maxPercent: 100,
      hasNegative: false,
      showNegativeMarks: false,
      marks: {},
    };
  },
  created() {
    console.log(this.licenseAvg, this.candidate);
    // this.marks = this.processMarks(this.assessment.marksList);
    // this.hasNegative = this.assessment.marksList.some((m) => m < 0);
    // this.processTest(this.assessment);
  },
  methods: {
    processMarks(marksList) {
      let marks = {};
      marksList.forEach((mark, index) => {
        if (marks[mark]) {
          marks[mark].push(index);
        } else {
          marks[mark] = [index];
        }
      });
      return marks;
    },
    toggleNegativeMarks() {
      this.showNegativeMarks = !this.showNegativeMarks;
      let negativeCircle = document.getElementById("negative-circle");
      if (this.showNegativeMarks) {
        negativeCircle.style.zIndex = "9993634999";
        negativeCircle.style.height = "45px";
        negativeCircle.style.width = "45px";
        negativeCircle.style.borderRadius = "30px";
      } else {
        negativeCircle.style.zIndex = "0";
        negativeCircle.style.height = "35px";
        negativeCircle.style.width = "35px";
        negativeCircle.style.borderRadius = "20px";
      }
    },
    roundToTwo(num) {
      return Math.round(num);
    },
    startMouseOver(type, j) {
      const id = `${j}${type}`;
      const element = document.getElementById(id);

      if (element) {
        element.style.zIndex = "9993634999";
        element.style.height = "40px";
        element.style.width = "40px";
        element.style.borderRadius = "30px";

        // let left = marks - 1;
        // let right = marks + 1;
        // while (
        //   left > 0 &&
        //   this.assessment.testSummary.testChecks[left].present
        // ) {
        //   this.assessment.testSummary.testChecks[left--].subhovered = true;
        // }
        // while (
        //   right < this.assessment.testSummary.testChecks.length &&
        //   this.assessment.testSummary.testChecks[right].present
        // ) {
        //   this.assessment.testSummary.testChecks[right++].subhovered = true;
        // }
        this.$forceUpdate();
      }
    },

    stopMouseOver(type, j, marks) {
      const id = `${j}${type}`;
      const element = document.getElementById(id);

      if (element) {
        element.style.zIndex = marks >= 0 ? marks : 0;
        element.style.height = "35px";
        element.style.width = "35px";

        // let left = marks - 1;
        // let right = marks + 1;

        // while (
        //   left > 0 &&
        //   this.assessment.testSummary.testChecks[left].present
        // ) {
        //   this.assessment.testSummary.testChecks[left--].subhovered = false;
        // }
        // while (
        //   right < this.assessment.testSummary.testChecks.length &&
        //   this.assessment.testSummary.testChecks[right].present
        // ) {
        //   this.assessment.testSummary.testChecks[right++].subhovered = false;
        // }
        this.$forceUpdate();
      }
    },
    processTest(test) {
      test.testSummary["testChecks"] = this.generateTestChecks(test);
    },
    generateTestChecks(test) {
      const testChecks = [];

      for (let j = 0; j <= test.testSummary.maxTestMarks; j++) {
        testChecks[j] = this.checkTestMarkPresence(j, test.marksList);
      }

      return testChecks;
    },
    checkTestMarkPresence(mark, marksList) {
      return marksList.some((m) => mark === m);
    },
  },
};
</script>

<style>
.testrankingbar {
  box-sizing: border-box;
  height: 18px;
  margin: 30px;
  background: #20639b;
  border: 0.5px solid #c4c4c4;
  box-shadow: 0px 0px 5px rgb(86 86 86 / 20%);
  border-radius: 11px;
}

.average-negative {
  width: 7px;
  height: 25px;
  border-radius: 11px;
  position: absolute;
  border: 0.46px solid #20639b;
  background: #ffffff;
}

.avg-marks {
  position: absolute;
  align-items: center;
  display: flex;
  top: -32px;
  width: max-content;
}

.text-pos {
  position: relative;
  align-items: center;
  display: flex;
  top: 28px;
}

.cp-datetext {
  font-weight: 400;
  font-size: 12px;
  color: #6d6d6d;
}

.cp-asmnttext {
  font-weight: 600;
  font-size: 12px;
  color: #696969;
}

.positive-circle {
  width: 35px;
  height: 35px;
  border-radius: 20px;
  /* border: 4px solid white; */
  background: #038e00;
  position: absolute;
}

.negative-circle {
  width: 35px;
  height: 35px;
  border-radius: 20px;
  border: 4px solid white;
  background: #eb0002;
  position: absolute;
}

.cp-asmnttext-new {
  font-weight: 600;
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
}

.negative-mark-box {
  box-shadow: 0px 2px 16px 0px #00000040;
  background-color: #ffffff;
  border-radius: 8px;
  width: 180px;
  position: absolute;
  padding: 13px 10px;
  bottom: 22px;
  right: -144px;
}

.neg-txt-1 {
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #3a3c40;
}

.neg-txt-2 {
  font-family: "Lato", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #3a3c40;
}

.neg-red-txt {
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #eb0002;
}
</style>
